import { Component, Input, OnInit  } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { ApplicationContextService, RolePermissionService } from 'lib-core-shared';
import { ControlBaseDirective } from '../../directives/control-base.directive';

@Component({
  selector: 'lib-select-box',
  templateUrl: './select-box.component.html',
  styleUrls: ['./select-box.component.scss']
})
export class SelectBoxComponent  extends ControlBaseDirective {
  @Input() source: any[] = [];
  @Input() showOptionCode: boolean = false;
  @Input() sourceType: string = '';
  @Input() defaultOptionMessage!: string;
  @Input() defaultOptionDisabled:  boolean | null = null;
  @Input() sourceIsLoading: boolean = false;
  @Input() optionsType: string = 'object';
  @Input() appendOther: boolean = false;
  @Input() disableSelectBox?: boolean ;
  constructor(public roleService: RolePermissionService, public applicationContext: ApplicationContextService) { 
    super(roleService, applicationContext);
   }
   public compareFn(option: any, selected: any): boolean {
    if ( option && selected ) {
      const fieleIdName = selected['id'] ? 'id' :  selected['code'] ? 'code': '-1';
      if (fieleIdName === '-1' ) {
        return option && selected ? option  === selected :false;
      } else {
        return option && selected ?
          option[fieleIdName] === selected[fieleIdName] :false;
      }
    }
    return false;
  }
}
